module.exports = __webpack_public_path__ + "media/images/sales/live-endroll/text-mv-copy-3c74d203ee8b6b27170977f3524b5c98.svg";